import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import { APP_NAME } from "../config";
import { useUnread } from "../utils/unread";

// The name of a role as people say it: "missions-coordinator" -> "Missions coordinator".
const roleLabel = (role) => {
    const name = (role || "").trim().replace(/^"|"$/g, "").replace(/-/g, " ");
    if (!name || name === "user") return "";
    if (name === "superadmin") return "Super admin";
    return name.charAt(0).toUpperCase() + name.slice(1);
};

function DashboardHeader() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [isDropdownActive, setIsDropdownActive] = useState(false);
    const toggleDropDownRef = useRef(null);
    const role = roleLabel(localStorage.getItem("userRole"));
    const unread = useUnread();

    useEffect(() => {
        // Check if user is logged in by fetching user data from localStorage or sessionStorage
        const loggedInUser = localStorage.getItem('user');
        if (loggedInUser) {
            setUser(JSON.parse(loggedInUser));
        } else {
            navigate('/login');
        }
    }, [navigate]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (

                toggleDropDownRef.current &&
                !toggleDropDownRef.current.contains(event.target) // Exclude toggle button
            ) {
                setIsDropdownActive(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsDropdownActive(!isDropdownActive);
    };

    return (
        <nav className="cf-dash-bar" role="navigation" aria-label="dash navigation">
            {/* The logo is here on a phone, where the side menu is hidden until it is opened. */}
            <Link className="cf-dash-bar-logo" to="/dashboard" id="logoLink" aria-label="Dashboard">
                <BrandLogo size={30} />
            </Link>

            <div className="cf-header-centre">{APP_NAME}</div>

            <div className="cf-dash-actions">
                {/* The bell: the number of unread notifications, and the way to the list. */}
                <Link
                    className="cf-bell"
                    to="/dashboard/notifications"
                    aria-label={unread > 0 ? `Notifications, ${unread} unread` : "Notifications"}
                    title="Notifications"
                >
                    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                    </svg>
                    {unread > 0 && <span className="cf-bell-count" aria-hidden="true">{unread > 99 ? "99+" : unread}</span>}
                </Link>

                <div className={`cf-user cf-dash-user ${isDropdownActive ? "is-open" : ""}`} ref={toggleDropDownRef}>
                    <button
                        type="button"
                        className="cf-dash-user-button"
                        aria-haspopup="true"
                        aria-expanded={isDropdownActive}
                        onClick={toggleDropdown}
                    >
                        <span className="cf-dash-user-name">
                            {user?.first_name} {user?.last_name}
                            {role && <span className="cf-muted cf-header-role">&nbsp;&middot; {role}</span>}
                        </span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
                    </button>

                    <div className="cf-user-menu" role="menu">
                        <Link to="/dashboard/profile">Profile</Link>
                        <Link to="/dashboard/notifications">Notifications{unread > 0 ? ` (${unread})` : ""}</Link>
                        <Link to="/">Exit Dashboard</Link>
                        <hr />
                        <Link to="/dashboard/profile/reset-password">Reset Password</Link>
                        <Link to="/logout">Log Out</Link>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default DashboardHeader;
